export function translateResMessage(resMessage,defaultMes='') {
    let translateResult = ""
    if (resMessage == "密码错误") {
        translateResult = "h.common.resMessageTip1"
    } else if (resMessage == "密码长度应该在6到20之间") {
        translateResult = "h.common.resMessageTip2"
    } else if (resMessage == "账号错误") {
        translateResult = "h.common.resMessageTip3"
    } else if (resMessage == "验证码已下发") {
        translateResult = "h.common.resMessageTip4"
    } else if (resMessage == "验证码下发失败") {
        translateResult = "h.common.resMessageTip5"
    } else if (resMessage == "验证码已过期") {
        translateResult = "h.common.resMessageTip6"
    } else if (resMessage == "密码错误") {
        translateResult = "h.common.resMessageTip7"
    } else if (resMessage == "密码不可以与旧密码相同") {
        translateResult = "h.common.resMessageTip8"
    } else if (resMessage == "邮箱已存在") {
        translateResult = "h.common.resMessageTip9"
    }else if (resMessage == "获取成功") {
        translateResult = "h.common.resMessageTip14"
    }else if (resMessage == "登录成功") {
        translateResult = "h.common.resMessageTip20"
    }else if (resMessage == "验证码有误") {
        translateResult = "h.common.resMessageTip24"
    }

    if (resMessage==""){
        resMessage = defaultMes //如果遇到意外的错误，直接返回默认值
        if (resMessage == "注册成功") {
            translateResult = "h.common.resMessageTip10"
        } else if (resMessage == "注册失败") {
            translateResult = "h.common.resMessageTip11"
        } else if (resMessage == "修改用户信息成功") {
            translateResult = "h.common.resMessageTip12"
        } else if (resMessage == "修改用户信息失败") {
            translateResult = "h.common.resMessageTip13"
        } else if (resMessage == "获取失败") {
            translateResult = "h.common.resMessageTip15"
        } else if (resMessage == "修改密码成功") {
            translateResult = "h.common.resMessageTip16"
        } else if (resMessage == "修改密码失败") {
            translateResult = "h.common.resMessageTip17"
        } else if (resMessage == "重置密码成功") {
            translateResult = "h.common.resMessageTip18"
        } else if (resMessage == "重置密码失败") {
            translateResult = "h.common.resMessageTip19"
        } else if (resMessage == "登录失败") {
            translateResult = "h.common.resMessageTip21"
        } else if (resMessage == "删除账号成功") {
            translateResult = "h.common.resMessageTip22"
        } else if (resMessage == "删除账号失败") {
            translateResult = "h.common.resMessageTip23"
        } else {
            console.error(defaultMes)
        }
    }

    return translateResult
}



// WEBPACK FOOTER //
// ./src/utils/translateResMessage.js